// extracted by mini-css-extract-plugin
module.exports = {"container":"_38PabN","heading":"_2pgGwZ","buttonWrapper":"_349k7k","button1":"_2_nPUA","button2":"g6W05C","button":"_1lmI_n"};